export const SETTINGS_KEYS = [
  "timezone",
  "address",
  "repo_th",
  "similarity_addition",
  "valid_th_from",
  "valid_th_to",
] as const;

export type SettingKey = typeof SETTINGS_KEYS[number];

export const SETTING_LABELS: Record<SettingKey, string> = {
  timezone: "Timezone",
  address: "Address",
  repo_th: "Repository Threshold",
  similarity_addition: "Similarity Addition",
  valid_th_from: "Valid Threshold From",
  valid_th_to: "Valid Threshold To",
};

export const DEFAULT_SETTINGS_VALUES = {
  repo_th: 0,
  similarity_addition: 0,
  valid_th_from: 0,
  valid_th_to: 0,
} as const;
